export enum ProfileLinkCategoryEnum {
    FINANCE_AND_PAYMENTS = 'Финансы и выплаты',
    CONTRACTS = 'Договоры',
    EMPLOYEES = 'Сотрудники',
    INSTRUCTION = 'Инструкция по работе с агентским порталом',
    HELP = 'Нужна помощь или остались вопросы?',
}

export enum ProfileDomainEnum {
    DEFAULT = 'main?',
    FINANCE_AND_PAYMENTS = 'documents/bills?',
    CONTRACTS = 'documents/contracts?',
    EMPLOYEES = 'business/organization/partyId?section=employees&',
}